import { render, staticRenderFns } from "./Setup_OrdersReasons.vue?vue&type=template&id=74914e70&scoped=true&"
import script from "./Setup_OrdersReasons.vue?vue&type=script&lang=js&"
export * from "./Setup_OrdersReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74914e70",
  null
  
)

export default component.exports